export enum SMSorEmailCommunicationType
{
    TextHome = 1,
    TextWork = 2,
    TextOther = 3,
    Email = 4,
    TextOverride = 5,
    EmailOverride = 6,
}